import { RouteRecordRaw } from 'vue-router'
import HomeVue from '@/views/Home.vue'
import RedirectVue from '@/views/Redirect/Redirect.vue'
import RegisterVue from '@/views/Register/Register.vue'

export const unauthenticatedRoutes: Array<RouteRecordRaw> = [
      {
        path: '/',
        name: 'Home',
        component: HomeVue,
      },
      {
        path: '/redirect',
        name: 'Redirect',
        component: RedirectVue
      },
      {
        path: '/register',
        name: 'Register',
        component: RegisterVue
      }
    ]